"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Wordlists
// See: https://github.com/bitcoin/bips/blob/master/bip-0039/bip-0039-wordlists.md
var wordlist_1 = require("./wordlist");
exports.Wordlist = wordlist_1.Wordlist;
var lang_en_1 = require("./lang-en");
var wordlists = { en: lang_en_1.langEn };
exports.wordlists = wordlists;
//# sourceMappingURL=browser.js.map